
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-penilik/tim-kinerja/pelaksanaan/beranda",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-penilik/tim-kinerja/pelaksanaan/beranda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-penilik/tim-kinerja/pelaksanaan/beranda"])
      });
    }
  